module.exports = __webpack_public_path__ + "img/clipboard_report.0874e11e.png";